/**
 * Real data extracted from Google Calendar
 * Synced from Errigal hotel calendars for production use
 */

export const REAL_EVENTS = [
  // ===== WEDDINGS =====
  {
    id: 'evt001',
    name: 'Lauren McKeon & Paul Murray',
    client: 'Lauren McKeon & Paul Murray',
    clientPhone: '087 3457007',
    clientEmail: 'lauren.mckeon98@gmail.com',
    type: 'wedding',
    venue_id: 'skeff-full',
    date: '2026-05-28',
    startTime: '14:00',
    endTime: '23:30',
    guests: 200,
    stage: 'deposit_paid',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 11300,
    depositPaid: 5650,
    notes: 'Dream Midweek package €11300 for 120 guests + €65pp extra, est 200 guests. Photographer: Thomas Whyte. Band: Odd Time.',
    billingType: 'group',
    consumption: null,
    gcal_id: 'lauren_paul_wedding_2026',
    gcal_calendar: 'Weddings Confirmed and booked',
  },
  {
    id: 'evt002',
    name: 'Rebecca Gill & Mick Healy',
    client: 'Rebecca Gill & Mick Healy',
    clientPhone: '087 1352190',
    clientEmail: 'beccagill@msn.com',
    type: 'wedding',
    venue_id: 'skeff-full',
    date: '2026-05-30',
    startTime: '14:00',
    endTime: '23:30',
    guests: 150,
    stage: 'deposit_paid',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'All Inclusive Fairytale Apr-Oct. Groom: Mick Healy, phone: 086-1535450, email: healymichael126@gmail.com',
    billingType: 'group',
    consumption: null,
    gcal_id: 'rebecca_mick_wedding_2026',
    gcal_calendar: 'Weddings Confirmed and booked',
  },
  {
    id: 'evt003',
    name: 'Megan McDermott & Felim Shalvey',
    client: 'Megan McDermott & Felim Shalvey',
    clientPhone: '083 0148279',
    clientEmail: 'meganmcdermott95@icloud.com',
    type: 'wedding',
    venue_id: 'skeff-full',
    date: '2026-07-09',
    startTime: '14:00',
    endTime: '23:30',
    guests: 170,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 8500,
    depositPaid: 4250,
    notes: 'Midweek package €8500 for 120 guests + €75pp, 150/180 guests. Groom: Felim Shalvey, phone: 087-1206907.',
    billingType: 'group',
    consumption: null,
    gcal_id: 'megan_felim_wedding_2026',
    gcal_calendar: 'Weddings Confirmed and booked',
  },
  {
    id: 'evt004',
    name: 'Caroline Mullaney & Darren Smith',
    client: 'Caroline Mullaney & Darren Smith',
    clientPhone: '087 1925340',
    clientEmail: 'carolineanddarren@hotmail.com',
    type: 'wedding',
    venue_id: 'skeff-full',
    date: '2026-08-01',
    startTime: '14:00',
    endTime: '23:30',
    guests: 180,
    stage: 'deposit_paid',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 17000,
    depositPaid: 8500,
    notes: 'All Inclusive Apr-Oct €17000 for 150 guests + €70pp, est 150-200 guests. Groom: Darren Smith, phone: 087-6333039. Deposit paid, contracts signed.',
    billingType: 'group',
    consumption: null,
    gcal_id: 'caroline_darren_wedding_2026',
    gcal_calendar: 'Weddings Confirmed and booked',
  },
  {
    id: 'evt005',
    name: 'Anita Whyte & James Rutledge',
    client: 'Anita Whyte & James Rutledge',
    clientPhone: '087 7561318',
    clientEmail: 'anitawhyte72@gmail.com',
    type: 'wedding',
    venue_id: 'skeff-full',
    date: '2026-08-07',
    startTime: '14:00',
    endTime: '23:30',
    guests: 150,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 14000,
    depositPaid: 7000,
    notes: 'Fairytale Package €14000 for 150 guests. Groom: James Rutledge, phone: 086-0744999.',
    billingType: 'group',
    consumption: null,
    gcal_id: 'anita_james_wedding_2026',
    gcal_calendar: 'Weddings Confirmed and booked',
  },
  {
    id: 'evt006',
    name: 'Lisa Kelly & Liam Walsh',
    client: 'Lisa Kelly & Liam Walsh',
    clientPhone: '',
    clientEmail: '',
    type: 'wedding',
    venue_id: 'skeff-full',
    date: '2026-08-14',
    startTime: '14:00',
    endTime: '23:30',
    guests: 150,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Niall cousin so details to come later',
    billingType: 'group',
    consumption: null,
    gcal_id: 'lisa_liam_wedding_2026',
    gcal_calendar: 'Weddings Confirmed and booked',
  },
  {
    id: 'evt007',
    name: 'Emma McCann & Paddy Rodgers',
    client: 'Emma McCann & Paddy Rodgers',
    clientPhone: '07539894988',
    clientEmail: 'emmamccann95@live.co.uk',
    type: 'wedding',
    venue_id: 'skeff-full',
    date: '2026-08-29',
    startTime: '14:00',
    endTime: '23:30',
    guests: 190,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 16150,
    depositPaid: 8075,
    notes: 'Romance package €85pp, 180-200 guests. Groom: Paddy Rodgers, phone: 07799425798, email: paddy.rodgers@hotmail.com.',
    billingType: 'group',
    consumption: null,
    gcal_id: 'emma_paddy_wedding_2026',
    gcal_calendar: 'Weddings Confirmed and booked',
  },
  {
    id: 'evt008',
    name: 'Nicole Cooney & Aaron Mitchell',
    client: 'Nicole Cooney & Aaron Mitchell',
    clientPhone: '00447454293274',
    clientEmail: 'nicole-cooney@hotmail.co.uk',
    type: 'wedding',
    venue_id: 'skeff-full',
    date: '2026-09-03',
    startTime: '14:00',
    endTime: '23:30',
    guests: 75,
    stage: 'deposit_paid',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 6000,
    depositPaid: 3000,
    notes: 'Intimate Package €6000 for 75 guests. Groom: Aaron Mitchell, phone: 00447875073709, email: Az7@hotmail.co.uk. Band Temptations €1500, Thomas Whyte photos €1500. Raymond paid deposit.',
    billingType: 'group',
    consumption: null,
    gcal_id: 'nicole_aaron_wedding_2026',
    gcal_calendar: 'Weddings Confirmed and booked',
  },
  {
    id: 'evt009',
    name: 'Margret Seamunds & Sean Connolly',
    client: 'Margret Seamunds & Sean Connolly',
    clientPhone: '083 0074541',
    clientEmail: 'margretdoesmakeup@gmail.com',
    type: 'wedding',
    venue_id: 'skeff-full',
    date: '2026-10-10',
    startTime: '14:00',
    endTime: '23:30',
    guests: 100,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 8500,
    depositPaid: 4250,
    notes: 'Romance Package €85pp for 100 guests (min 100). Groom: Sean Connolly.',
    billingType: 'group',
    consumption: null,
    gcal_id: 'margret_sean_wedding_2026',
    gcal_calendar: 'Weddings Confirmed and booked',
  },
  {
    id: 'evt010',
    name: 'Sarah McCaffery & Daniel McFarland',
    client: 'Sarah McCaffery & Daniel McFarland',
    clientPhone: '087 0579269',
    clientEmail: 'sarahlouisemcc@yahoo.com',
    type: 'wedding',
    venue_id: 'skeff-full',
    date: '2026-11-06',
    startTime: '14:00',
    endTime: '23:30',
    guests: 150,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Everything You Need Package Jan/Feb. Groom: Daniel McFarland, phone: 00447594140332. Originally Feb 20, changed to Nov 6.',
    billingType: 'group',
    consumption: null,
    gcal_id: 'sarah_daniel_wedding_2026',
    gcal_calendar: 'Weddings Confirmed and booked',
  },
  {
    id: 'evt011',
    name: 'Mairead Fitzsimons & Kieran Smith',
    client: 'Mairead Fitzsimons & Kieran Smith',
    clientPhone: '086 1053441',
    clientEmail: 'mftizsimons0611@gmail.com',
    type: 'wedding',
    venue_id: 'skeff-full',
    date: '2026-11-14',
    startTime: '14:00',
    endTime: '23:30',
    guests: 180,
    stage: 'deposit_paid',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 14500,
    depositPaid: 7250,
    notes: 'All Inclusive Nov €14500 for 150 + €70pp. Groom: Kieran Smith, phone: 086-2760315, email: kieransmith2468@gmail.com.',
    billingType: 'group',
    consumption: null,
    gcal_id: 'mairead_kieran_wedding_2026',
    gcal_calendar: 'Weddings Confirmed and booked',
  },
  {
    id: 'evt012',
    name: 'Aoibheann Deery & James Conlon',
    client: 'Aoibheann Deery & James Conlon',
    clientPhone: '087 3513565',
    clientEmail: 'aoibheanndeery@gmail.com',
    type: 'wedding',
    venue_id: 'skeff-full',
    date: '2027-01-01',
    startTime: '14:00',
    endTime: '23:30',
    guests: 225,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 14000,
    depositPaid: 7000,
    notes: 'New Years Day wedding. €14000 for 150 + €95pp, 200-250 est. Groom: James Conlon, phone: 087-2732686, email: jamesconlon11@gmail.com.',
    billingType: 'group',
    consumption: null,
    gcal_id: 'aoibheann_james_wedding_2027',
    gcal_calendar: 'Weddings Confirmed and booked',
  },
  {
    id: 'evt013',
    name: 'Natalie Mone & Kyle Plummer',
    client: 'Natalie Mone & Kyle Plummer',
    clientPhone: '00447858524653',
    clientEmail: 'kyleandnataileswedding@gmail.com',
    type: 'wedding',
    venue_id: 'skeff-full',
    date: '2027-06-05',
    startTime: '14:00',
    endTime: '23:30',
    guests: 260,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 15500,
    depositPaid: 7750,
    notes: '€15500 for 180 guests + 80 cocktails + extra bedroom. Groom: Kyle Plummer, phone: 086-1265638.',
    billingType: 'group',
    consumption: null,
    gcal_id: 'natalie_kyle_wedding_2027',
    gcal_calendar: 'Weddings Confirmed and booked',
  },
  {
    id: 'evt014',
    name: 'Aoife Finnegan & James Goodman',
    client: 'Aoife Finnegan & James Goodman',
    clientPhone: '087 1143774',
    clientEmail: 'aoifefinnegan21@gmail.com',
    type: 'wedding',
    venue_id: 'skeff-full',
    date: '2027-07-29',
    startTime: '14:00',
    endTime: '23:30',
    guests: 150,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 12300,
    depositPaid: 6150,
    notes: 'Midweek Dream €12300 for 2027. Groom: James Goodman, phone: 087-1529403, email: jamesgoodman02@gmail.com.',
    billingType: 'group',
    consumption: null,
    gcal_id: 'aoife_james_wedding_2027',
    gcal_calendar: 'Weddings Confirmed and booked',
  },
  {
    id: 'evt015',
    name: 'Haylee Cooper & Christopher Kelly',
    client: 'Haylee Cooper & Christopher Kelly',
    clientPhone: '087 3989764',
    clientEmail: 'hayley-cooper@hotmail.com',
    type: 'wedding',
    venue_id: 'skeff-full',
    date: '2027-09-04',
    startTime: '14:00',
    endTime: '23:30',
    guests: 300,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Est 300ppl. Groom: Christopher Kelly, phone: 087-4514030.',
    billingType: 'group',
    consumption: null,
    gcal_id: 'haylee_christopher_wedding_2027',
    gcal_calendar: 'Weddings Confirmed and booked',
  },
  {
    id: 'evt016',
    name: 'Wedding (Niall)',
    client: 'Niall',
    clientPhone: '',
    clientEmail: '',
    type: 'wedding',
    venue_id: 'skeff-full',
    date: '2027-10-23',
    startTime: '14:00',
    endTime: '23:30',
    guests: 150,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'No other details',
    billingType: 'group',
    consumption: null,
    gcal_id: 'niall_wedding_2027',
    gcal_calendar: 'Weddings Confirmed and booked',
  },

  // ===== WEDDING ENQUIRIES / QUOTES =====
  {
    id: 'evt017',
    name: 'Casey & Paul Potential Wedding',
    client: 'Casey & Paul',
    clientPhone: '',
    clientEmail: '',
    type: 'wedding',
    venue_id: 'skeff-full',
    date: '2027-10-09',
    startTime: '14:00',
    endTime: '23:30',
    guests: 150,
    stage: 'quote_sent',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 14000,
    depositPaid: 0,
    notes: 'From Cookstown & Lisnaskea 150 guests. Fairytale wedding package 120 guests €12000 + 30 guests. quoted €12550 (discounted to €12250 until 31.1.26 - error in quote contacted them and quoted 14000 (-550 off what quote should have been))',
    billingType: 'group',
    consumption: null,
    gcal_id: 'casey_paul_wedding_2027',
    gcal_calendar: 'WeddingShowArounds and Wedding Meetings',
  },
  {
    id: 'evt018',
    name: 'Leah Wedding Provisional',
    client: 'Leah',
    clientPhone: '',
    clientEmail: '',
    type: 'wedding',
    venue_id: 'skeff-full',
    date: '2027-11-27',
    startTime: '14:00',
    endTime: '23:30',
    guests: 150,
    stage: 'quote_sent',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 14250,
    depositPaid: 0,
    notes: 'Enniskillen - 150 ppl. quoted €14250 to 31.1.26. Looking for quote for day 2 for foyer bar, package deal on rooms booked for two nights.',
    billingType: 'group',
    consumption: null,
    gcal_id: 'leah_wedding_2027',
    gcal_calendar: 'WeddingShowArounds and Wedding Meetings',
  },

  // ===== FUNCTIONS / PARTIES =====
  {
    id: 'evt019',
    name: 'Table Tennis Dinner Dance',
    client: 'Liam',
    clientPhone: '',
    clientEmail: '',
    type: 'private_party',
    venue_id: 'skeff-full',
    date: '2026-04-10',
    startTime: '19:00',
    endTime: '23:30',
    guests: 280,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Table Tennis Dinner Dance. No Details in book.. Liam Knows more. Usually around 280 guests. Half Bowl Soup, T/H, Braised Beef, Crumble',
    billingType: 'group',
    consumption: null,
    gcal_id: 'table_tennis_dinner_dance_2026',
    gcal_calendar: 'Booked Functions/Partys',
  },
  {
    id: 'evt020',
    name: 'St Aidans I\'m a Celeb',
    client: 'St Aidans',
    clientPhone: '',
    clientEmail: 'nicole@errigalhotel.com',
    type: 'charity',
    venue_id: 'skeff-full',
    date: '2026-04-17',
    startTime: '19:00',
    endTime: '23:30',
    guests: 500,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Skeff Suite. confirmed with liam on 11.1.26. 400-600 ppl',
    billingType: 'group',
    consumption: null,
    gcal_id: 'st_aidans_celeb_2026',
    gcal_calendar: 'Booked Functions/Partys',
  },
  {
    id: 'evt021',
    name: 'Parkinsons Function',
    client: 'Michelle Hall',
    clientPhone: '087 941 5593',
    clientEmail: '',
    type: 'charity',
    venue_id: 'skeff1',
    date: '2026-04-18',
    startTime: '09:00',
    endTime: '15:30',
    guests: 120,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Parkinsons Function for 100-120 ppl. Function room from 9am - 3.30pm. Michelle Hall contct. 0879415593. Katie. 0874082143. 2 course meal and tea coffe and biscuits. Price and details to be confirmed',
    billingType: 'group',
    consumption: null,
    gcal_id: 'parkinsons_function_2026',
    gcal_calendar: 'Booked Functions/Partys',
  },
  {
    id: 'evt022',
    name: 'Family Fun Day For Cuan',
    client: 'Cuan Cancer',
    clientPhone: '',
    clientEmail: '',
    type: 'charity',
    venue_id: 'skeff-full',
    date: '2026-05-03',
    startTime: '11:00',
    endTime: '17:00',
    guests: 200,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Going to do a family fun day like our 20th anniversary. all proceds to cuan cancer. Bouncy Castles, Face Painting, BBQ. Finalise all details at HOD meeting',
    billingType: 'group',
    consumption: null,
    gcal_id: 'cuan_fun_day_2026',
    gcal_calendar: 'Booked Functions/Partys',
  },
  {
    id: 'evt023',
    name: 'Holy Family Graduation Night',
    client: 'Holy Family School',
    clientPhone: '',
    clientEmail: '',
    type: 'private_party',
    venue_id: 'skeff-full',
    date: '2026-06-18',
    startTime: '19:00',
    endTime: '23:30',
    guests: 150,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Holy Family Graduation Night',
    billingType: 'group',
    consumption: null,
    gcal_id: 'holy_family_graduation_2026',
    gcal_calendar: 'Booked Functions/Partys',
  },
  {
    id: 'evt024',
    name: 'The Fogues',
    client: 'The Fogues',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'skeff-full',
    date: '2026-06-20',
    startTime: '19:00',
    endTime: '23:30',
    guests: 200,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: ['sound_system', 'stage'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'The Fogues live music event',
    billingType: 'group',
    consumption: null,
    gcal_id: 'fogues_2026',
    gcal_calendar: 'Booked Functions/Partys',
  },
  {
    id: 'evt025',
    name: 'Boylans Birthday',
    client: 'Boylan',
    clientPhone: '',
    clientEmail: '',
    type: 'private_party',
    venue_id: 'skeff1',
    date: '2026-08-15',
    startTime: '19:00',
    endTime: '23:30',
    guests: 60,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Skeff - 60ppl + 10bedrooms. Menu - package',
    billingType: 'group',
    consumption: null,
    gcal_id: 'boylan_birthday_2026',
    gcal_calendar: 'Booked Functions/Partys',
  },
  {
    id: 'evt026',
    name: 'OAPs Christmas Party',
    client: 'OAPs Group',
    clientPhone: '',
    clientEmail: '',
    type: 'private_party',
    venue_id: 'skeff-full',
    date: '2026-12-13',
    startTime: '19:00',
    endTime: '23:30',
    guests: 200,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Usual doooo',
    billingType: 'group',
    consumption: null,
    gcal_id: 'oaps_xmas_2026',
    gcal_calendar: 'Booked Functions/Partys',
  },
  {
    id: 'evt027',
    name: 'XMAS Party Night',
    client: 'XMAS Party',
    clientPhone: '',
    clientEmail: '',
    type: 'private_party',
    venue_id: 'skeff-full',
    date: '2026-12-19',
    startTime: '19:00',
    endTime: '23:30',
    guests: 150,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'XMAS Party Night',
    billingType: 'group',
    consumption: null,
    gcal_id: 'xmas_party_2026',
    gcal_calendar: 'Booked Functions/Partys',
  },
  {
    id: 'evt028',
    name: 'Xmas Party - Vertigo',
    client: 'Vertigo',
    clientPhone: '',
    clientEmail: '',
    type: 'private_party',
    venue_id: 'skeff-full',
    date: '2027-12-18',
    startTime: '19:00',
    endTime: '23:30',
    guests: 150,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: ['sound_system', 'stage'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 1600,
    depositPaid: 800,
    notes: 'Vertigo booked and confirmed for xmas party night. €1600 for band and dj.',
    billingType: 'group',
    consumption: null,
    gcal_id: 'vertigo_xmas_2027',
    gcal_calendar: 'Booked Functions/Partys',
  },

  // ===== COMMUNIONS / CONFIRMATIONS =====
  {
    id: 'evt029',
    name: 'Confirmation',
    client: 'School',
    clientPhone: '',
    clientEmail: '',
    type: 'private_party',
    venue_id: 'skeff-full',
    date: '2026-04-24',
    startTime: '14:00',
    endTime: '18:00',
    guests: 150,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Confirmation all in skeff',
    billingType: 'group',
    consumption: null,
    gcal_id: 'confirmation_skeff_2026',
    gcal_calendar: 'Communion and Confirmations',
  },
  {
    id: 'evt030',
    name: 'Communion in Shercock',
    client: 'Shercock Parish',
    clientPhone: '',
    clientEmail: '',
    type: 'private_party',
    venue_id: 'skeff-full',
    date: '2026-05-09',
    startTime: '14:00',
    endTime: '18:00',
    guests: 150,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Communion in Shercock',
    billingType: 'group',
    consumption: null,
    gcal_id: 'communion_shercock_2026',
    gcal_calendar: 'Communion and Confirmations',
  },
  {
    id: 'evt031',
    name: 'Communion',
    client: 'School',
    clientPhone: '',
    clientEmail: '',
    type: 'private_party',
    venue_id: 'skeff-full',
    date: '2026-05-16',
    startTime: '14:00',
    endTime: '18:00',
    guests: 150,
    stage: 'confirmed',
    setup: 'banquet',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Communion',
    billingType: 'group',
    consumption: null,
    gcal_id: 'communion_2026',
    gcal_calendar: 'Communion and Confirmations',
  },

  // ===== CORPORATE / MEETINGS =====
  {
    id: 'evt032',
    name: 'Margaret Connolly - Makeup Artist',
    client: 'Margaret Connolly',
    clientPhone: '',
    clientEmail: '',
    type: 'corporate',
    venue_id: 'corrick',
    date: '2026-04-06',
    startTime: '09:00',
    endTime: '17:00',
    guests: 4,
    stage: 'confirmed',
    setup: 'boardroom',
    equipment: [],
    fbItems: [],
    roomHire: 190,
    packageTotal: 190,
    depositPaid: 190,
    notes: 'Makeup Artist - Corrick full day',
    billingType: 'group',
    consumption: null,
    gcal_id: 'margaret_makeup_2026',
    gcal_calendar: 'Meetings',
  },
  {
    id: 'evt033',
    name: 'Holistic Fairs Ireland',
    client: 'Holistic Fairs Ireland',
    clientPhone: '',
    clientEmail: '',
    type: 'corporate',
    venue_id: 'skeff-full',
    date: '2026-04-26',
    startTime: '08:00',
    endTime: '18:00',
    guests: 150,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: [],
    fbItems: ['tea_coffee'],
    roomHire: 400,
    packageTotal: 400,
    depositPaid: 400,
    notes: 'Room hire 400 euro. tea coffee at 11.30 for 150 people to be set up in wedding foyer',
    billingType: 'group',
    consumption: null,
    gcal_id: 'holistic_fairs_2026',
    gcal_calendar: 'Meetings',
  },
  {
    id: 'evt034',
    name: 'Bluecrest Meeting - Corrick',
    client: 'Bluecrest',
    clientPhone: '',
    clientEmail: '',
    type: 'corporate',
    venue_id: 'corrick',
    date: '2026-04-30',
    startTime: '07:00',
    endTime: '19:00',
    guests: 8,
    stage: 'confirmed',
    setup: 'boardroom',
    equipment: [],
    fbItems: [],
    roomHire: 190,
    packageTotal: 190,
    depositPaid: 190,
    notes: 'Bluecrest - 7am-7pm',
    billingType: 'group',
    consumption: null,
    gcal_id: 'bluecrest_corrick_2026',
    gcal_calendar: 'Meetings',
  },
  {
    id: 'evt035',
    name: 'Bluecrest Meeting - Corrick',
    client: 'Bluecrest',
    clientPhone: '',
    clientEmail: '',
    type: 'corporate',
    venue_id: 'corrick',
    date: '2026-06-24',
    startTime: '07:00',
    endTime: '19:00',
    guests: 8,
    stage: 'confirmed',
    setup: 'boardroom',
    equipment: [],
    fbItems: [],
    roomHire: 190,
    packageTotal: 190,
    depositPaid: 190,
    notes: 'Bluecrest - 7am-7pm',
    billingType: 'group',
    consumption: null,
    gcal_id: 'bluecrest_corrick_2_2026',
    gcal_calendar: 'Meetings',
  },
  {
    id: 'evt036',
    name: 'EU Presidency Conference',
    client: 'EU Presidency',
    clientPhone: '',
    clientEmail: '',
    type: 'corporate',
    venue_id: 'skeff-full',
    date: '2026-09-22',
    startTime: '09:00',
    endTime: '17:00',
    guests: 150,
    stage: 'confirmed',
    setup: 'classroom',
    equipment: ['projector', 'sound_system'],
    fbItems: ['morning_tea', 'lunch', 'afternoon_tea'],
    roomHire: 400,
    packageTotal: 400,
    depositPaid: 400,
    notes: 'Buffet will confirm menu.... Classroom style 150 all day conference 150 ppl. 3 days to Sep 25',
    billingType: 'group',
    consumption: null,
    gcal_id: 'eu_presidency_conference_2026',
    gcal_calendar: 'Meetings',
  },
  {
    id: 'evt037',
    name: 'Wedding Showcase',
    client: 'Errigal Hotel',
    clientPhone: '',
    clientEmail: '',
    type: 'corporate',
    venue_id: 'skeff-full',
    date: '2026-05-23',
    startTime: '10:00',
    endTime: '17:00',
    guests: 100,
    stage: 'enquiry',
    setup: 'theatre',
    equipment: [],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Wedding Showcase Skeff. 2026-05-23 to 2026-05-25',
    billingType: 'group',
    consumption: null,
    gcal_id: 'wedding_showcase_2026',
    gcal_calendar: 'WeddingShowArounds and Wedding Meetings',
  },

  // ===== MUSIC NIGHTS =====
  {
    id: 'evt038',
    name: 'James Rose - Music in Bar',
    client: 'James Rose',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-04-05',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'James Rose. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'james_rose_2026_04_05',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt039',
    name: 'Alan - Mr Brightside',
    client: 'Alan',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-05-02',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 240,
    depositPaid: 120,
    notes: 'Alan, Mr Brightside. Music in Bar. €240',
    billingType: 'group',
    consumption: null,
    gcal_id: 'alan_brightside_2026_05_02',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt040',
    name: 'Aaron Hughes - Music in Bar',
    client: 'Aaron Hughes',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-05-03',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Aaron Hughes. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'aaron_hughes_2026_05_03',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt041',
    name: 'Shane McCluskey - Music in Bar',
    client: 'Shane McCluskey',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-05-24',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Shane McCluskey. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'shane_mccluskey_2026_05_24',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt042',
    name: 'Mick McLaughlin - Music in Bar',
    client: 'Mick McLaughlin',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-06-06',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Mick McLaughlin Bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'mick_mclaughlin_2026_06_06',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt043',
    name: 'Shane - Hot Pokers',
    client: 'Shane',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-06-13',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Shane, Hot Pokers. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'shane_hotpokers_2026_06_13',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt044',
    name: 'Niall O Reilly - Music in Bar',
    client: 'Niall O Reilly',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-06-26',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Niall O Reilly Music',
    billingType: 'group',
    consumption: null,
    gcal_id: 'niall_oreilly_2026_06_26',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt045',
    name: 'Michael Rafferty - Music in Bar',
    client: 'Michael Rafferty',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-06-27',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Michael Rafferty. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'michael_rafferty_2026_06_27',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt046',
    name: 'Mick McLaughlin - Music in Bar',
    client: 'Mick McLaughlin',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-07-04',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Music Mick McLaughlin - Bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'mick_mclaughlin_2026_07_04',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt047',
    name: 'Aaron Hughes - Music in Bar',
    client: 'Aaron Hughes',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-07-11',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Aaron Hughes. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'aaron_hughes_2026_07_11',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt048',
    name: 'Niall O Reilly - Music in Bar',
    client: 'Niall O Reilly',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-07-18',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Niall O Reilly. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'niall_oreilly_2026_07_18',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt049',
    name: 'Shane Reynolds - Music in Bar',
    client: 'Shane Reynolds',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-07-25',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Shane Reynolds. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'shane_reynolds_2026_07_25',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt050',
    name: 'Aaron Hughes - Music in Bar',
    client: 'Aaron Hughes',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-08-02',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Aaron Hughes. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'aaron_hughes_2026_08_02',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt051',
    name: 'Michael Rafferty - Music in Bar',
    client: 'Michael Rafferty',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-08-08',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Michael Rafferty. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'michael_rafferty_2026_08_08',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt052',
    name: 'Mick McLaughlin - Music in Bar',
    client: 'Mick McLaughlin',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-08-15',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Mick McLaughlin. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'mick_mclaughlin_2026_08_15',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt053',
    name: 'Niall O Reilly - Music in Bar',
    client: 'Niall O Reilly',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-08-21',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Music Booked. Niall O Reilly',
    billingType: 'group',
    consumption: null,
    gcal_id: 'niall_oreilly_2026_08_21',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt054',
    name: 'Shane Reynolds - Music in Bar',
    client: 'Shane Reynolds',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-08-22',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Shane Reynolds. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'shane_reynolds_2026_08_22',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt055',
    name: 'Shane McCluskey - Music in Bar',
    client: 'Shane McCluskey',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-08-30',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Shane Mc Cluskey. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'shane_mccluskey_2026_08_30',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt056',
    name: 'Alan - Mr Brightside',
    client: 'Alan',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-09-05',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Alan. Mr Brightside. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'alan_brightside_2026_09_05',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt057',
    name: 'Shane Reynolds - Music in Bar',
    client: 'Shane Reynolds',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-09-12',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Shane Reynolds. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'shane_reynolds_2026_09_12',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt058',
    name: 'James Rose - Music in Bar',
    client: 'James Rose',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-09-19',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'James Rose. Music in Bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'james_rose_2026_09_19',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt059',
    name: 'Alan - Mr Brightside',
    client: 'Alan',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-09-26',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Alan, Mr Brightside. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'alan_brightside_2026_09_26',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt060',
    name: 'Alan - Mr Brightside',
    client: 'Alan',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-10-24',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Alan. Mr Brightside. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'alan_brightside_2026_10_24',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt061',
    name: 'Michael Rafferty - Music in Bar',
    client: 'Michael Rafferty',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-10-25',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Michael Rafferty. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'michael_rafferty_2026_10_25',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt062',
    name: 'Shane - Hot Pokers',
    client: 'Shane',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-10-31',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Shane, HotPokers. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'shane_hotpokers_2026_10_31',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt063',
    name: 'Shane Reynolds - Music in Bar',
    client: 'Shane Reynolds',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-12-05',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Shane Reynolds. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'shane_reynolds_2026_12_05',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt064',
    name: 'Shane McCluskey - Music in Bar',
    client: 'Shane McCluskey',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-12-12',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Shane McCluskey. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'shane_mccluskey_2026_12_12',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt065',
    name: 'Mick McLaughlin - Music in Bar',
    client: 'Mick McLaughlin',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-12-19',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Mick McLaughlin.. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'mick_mclaughlin_2026_12_19',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt066',
    name: 'Niall O Reilly - Music in Bar',
    client: 'Niall O Reilly',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-12-20',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Niall O Reilly.. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'niall_oreilly_2026_12_20',
    gcal_calendar: 'Music booked',
  },
  {
    id: 'evt067',
    name: 'Niall O Reilly - Music in Bar',
    client: 'Niall O Reilly',
    clientPhone: '',
    clientEmail: '',
    type: 'music_night',
    venue_id: 'brewery',
    date: '2026-12-29',
    startTime: '21:00',
    endTime: '23:30',
    guests: 50,
    stage: 'confirmed',
    setup: 'theatre',
    equipment: ['sound_system'],
    fbItems: [],
    roomHire: 0,
    packageTotal: 0,
    depositPaid: 0,
    notes: 'Niall O Reilly. Music in bar',
    billingType: 'group',
    consumption: null,
    gcal_id: 'niall_oreilly_2026_12_29',
    gcal_calendar: 'Music booked',
  },
];

export const REAL_CLIENTS = [
  // Wedding Couples
  {
    id: 1,
    name: 'Lauren McKeon & Paul Murray',
    company: '',
    phone: '087 3457007',
    email: 'lauren.mckeon98@gmail.com',
    tag: 'wedding',
    totalEvents: 1,
    totalRevenue: 11300,
    lastEvent: '2026-05-28',
  },
  {
    id: 2,
    name: 'Rebecca Gill & Mick Healy',
    company: '',
    phone: '087 1352190',
    email: 'beccagill@msn.com',
    tag: 'wedding',
    totalEvents: 1,
    totalRevenue: 0,
    lastEvent: '2026-05-30',
  },
  {
    id: 3,
    name: 'Megan McDermott & Felim Shalvey',
    company: '',
    phone: '083 0148279',
    email: 'meganmcdermott95@icloud.com',
    tag: 'wedding',
    totalEvents: 1,
    totalRevenue: 8500,
    lastEvent: '2026-07-09',
  },
  {
    id: 4,
    name: 'Caroline Mullaney & Darren Smith',
    company: '',
    phone: '087 1925340',
    email: 'carolineanddarren@hotmail.com',
    tag: 'wedding',
    totalEvents: 1,
    totalRevenue: 17000,
    lastEvent: '2026-08-01',
  },
  {
    id: 5,
    name: 'Anita Whyte & James Rutledge',
    company: '',
    phone: '087 7561318',
    email: 'anitawhyte72@gmail.com',
    tag: 'wedding',
    totalEvents: 1,
    totalRevenue: 14000,
    lastEvent: '2026-08-07',
  },
  {
    id: 6,
    name: 'Lisa Kelly & Liam Walsh',
    company: '',
    phone: '',
    email: '',
    tag: 'wedding',
    totalEvents: 1,
    totalRevenue: 0,
    lastEvent: '2026-08-14',
  },
  {
    id: 7,
    name: 'Emma McCann & Paddy Rodgers',
    company: '',
    phone: '07539894988',
    email: 'emmamccann95@live.co.uk',
    tag: 'wedding',
    totalEvents: 1,
    totalRevenue: 16150,
    lastEvent: '2026-08-29',
  },
  {
    id: 8,
    name: 'Nicole Cooney & Aaron Mitchell',
    company: '',
    phone: '00447454293274',
    email: 'nicole-cooney@hotmail.co.uk',
    tag: 'wedding',
    totalEvents: 1,
    totalRevenue: 6000,
    lastEvent: '2026-09-03',
  },
  {
    id: 9,
    name: 'Margret Seamunds & Sean Connolly',
    company: '',
    phone: '083 0074541',
    email: 'margretdoesmakeup@gmail.com',
    tag: 'wedding',
    totalEvents: 1,
    totalRevenue: 8500,
    lastEvent: '2026-10-10',
  },
  {
    id: 10,
    name: 'Sarah McCaffery & Daniel McFarland',
    company: '',
    phone: '087 0579269',
    email: 'sarahlouisemcc@yahoo.com',
    tag: 'wedding',
    totalEvents: 1,
    totalRevenue: 0,
    lastEvent: '2026-11-06',
  },
  {
    id: 11,
    name: 'Mairead Fitzsimons & Kieran Smith',
    company: '',
    phone: '086 1053441',
    email: 'mftizsimons0611@gmail.com',
    tag: 'wedding',
    totalEvents: 1,
    totalRevenue: 14500,
    lastEvent: '2026-11-14',
  },
  {
    id: 12,
    name: 'Aoibheann Deery & James Conlon',
    company: '',
    phone: '087 3513565',
    email: 'aoibheanndeery@gmail.com',
    tag: 'wedding',
    totalEvents: 1,
    totalRevenue: 14000,
    lastEvent: '2027-01-01',
  },
  {
    id: 13,
    name: 'Natalie Mone & Kyle Plummer',
    company: '',
    phone: '00447858524653',
    email: 'kyleandnataileswedding@gmail.com',
    tag: 'wedding',
    totalEvents: 1,
    totalRevenue: 15500,
    lastEvent: '2027-06-05',
  },
  {
    id: 14,
    name: 'Aoife Finnegan & James Goodman',
    company: '',
    phone: '087 1143774',
    email: 'aoifefinnegan21@gmail.com',
    tag: 'wedding',
    totalEvents: 1,
    totalRevenue: 12300,
    lastEvent: '2027-07-29',
  },
  {
    id: 15,
    name: 'Haylee Cooper & Christopher Kelly',
    company: '',
    phone: '087 3989764',
    email: 'hayley-cooper@hotmail.com',
    tag: 'wedding',
    totalEvents: 1,
    totalRevenue: 0,
    lastEvent: '2027-09-04',
  },
  {
    id: 16,
    name: 'Niall',
    company: '',
    phone: '',
    email: '',
    tag: 'wedding',
    totalEvents: 1,
    totalRevenue: 0,
    lastEvent: '2027-10-23',
  },
  {
    id: 17,
    name: 'Casey & Paul',
    company: '',
    phone: '',
    email: '',
    tag: 'wedding',
    totalEvents: 1,
    totalRevenue: 14000,
    lastEvent: '2027-10-09',
  },
  {
    id: 18,
    name: 'Leah',
    company: '',
    phone: '',
    email: '',
    tag: 'wedding',
    totalEvents: 1,
    totalRevenue: 14250,
    lastEvent: '2027-11-27',
  },
  // Corporate / Functions
  {
    id: 19,
    name: 'Liam',
    company: '',
    phone: '',
    email: '',
    tag: 'other',
    totalEvents: 1,
    totalRevenue: 0,
    lastEvent: '2026-04-10',
  },
  {
    id: 20,
    name: 'St Aidans',
    company: '',
    phone: '',
    email: 'nicole@errigalhotel.com',
    tag: 'charity',
    totalEvents: 1,
    totalRevenue: 0,
    lastEvent: '2026-04-17',
  },
  {
    id: 21,
    name: 'Michelle Hall',
    company: 'Parkinsons',
    phone: '087 941 5593',
    email: '',
    tag: 'charity',
    totalEvents: 1,
    totalRevenue: 0,
    lastEvent: '2026-04-18',
  },
  {
    id: 22,
    name: 'Cuan Cancer',
    company: 'Cuan Cancer',
    phone: '',
    email: '',
    tag: 'charity',
    totalEvents: 1,
    totalRevenue: 0,
    lastEvent: '2026-05-03',
  },
  {
    id: 23,
    name: 'Holy Family School',
    company: 'Holy Family School',
    phone: '',
    email: '',
    tag: 'other',
    totalEvents: 1,
    totalRevenue: 0,
    lastEvent: '2026-06-18',
  },
  {
    id: 24,
    name: 'The Fogues',
    company: 'The Fogues',
    phone: '',
    email: '',
    tag: 'other',
    totalEvents: 1,
    totalRevenue: 0,
    lastEvent: '2026-06-20',
  },
  {
    id: 25,
    name: 'Boylan',
    company: '',
    phone: '',
    email: '',
    tag: 'other',
    totalEvents: 1,
    totalRevenue: 0,
    lastEvent: '2026-08-15',
  },
  {
    id: 26,
    name: 'OAPs Group',
    company: 'OAPs Group',
    phone: '',
    email: '',
    tag: 'other',
    totalEvents: 1,
    totalRevenue: 0,
    lastEvent: '2026-12-13',
  },
  {
    id: 27,
    name: 'XMAS Party',
    company: '',
    phone: '',
    email: '',
    tag: 'other',
    totalEvents: 1,
    totalRevenue: 0,
    lastEvent: '2026-12-19',
  },
  {
    id: 28,
    name: 'Vertigo',
    company: 'Vertigo',
    phone: '',
    email: '',
    tag: 'other',
    totalEvents: 1,
    totalRevenue: 1600,
    lastEvent: '2027-12-18',
  },
  {
    id: 29,
    name: 'Shercock Parish',
    company: 'Shercock Parish',
    phone: '',
    email: '',
    tag: 'other',
    totalEvents: 1,
    totalRevenue: 0,
    lastEvent: '2026-05-09',
  },
  {
    id: 30,
    name: 'Margaret Connolly',
    company: '',
    phone: '',
    email: '',
    tag: 'other',
    totalEvents: 1,
    totalRevenue: 190,
    lastEvent: '2026-04-06',
  },
  {
    id: 31,
    name: 'Holistic Fairs Ireland',
    company: 'Holistic Fairs Ireland',
    phone: '',
    email: '',
    tag: 'corporate',
    totalEvents: 1,
    totalRevenue: 400,
    lastEvent: '2026-04-26',
  },
  {
    id: 32,
    name: 'Bluecrest',
    company: 'Bluecrest',
    phone: '',
    email: '',
    tag: 'corporate',
    totalEvents: 2,
    totalRevenue: 380,
    lastEvent: '2026-06-24',
  },
  {
    id: 33,
    name: 'EU Presidency',
    company: 'EU Presidency',
    phone: '',
    email: '',
    tag: 'corporate',
    totalEvents: 1,
    totalRevenue: 400,
    lastEvent: '2026-09-22',
  },
  {
    id: 34,
    name: 'Errigal Hotel',
    company: 'Errigal Hotel',
    phone: '',
    email: '',
    tag: 'corporate',
    totalEvents: 1,
    totalRevenue: 0,
    lastEvent: '2026-05-23',
  },
  // Musicians
  {
    id: 35,
    name: 'James Rose',
    company: 'Musician',
    phone: '',
    email: '',
    tag: 'music',
    totalEvents: 2,
    totalRevenue: 0,
    lastEvent: '2026-09-19',
  },
  {
    id: 36,
    name: 'Alan',
    company: 'Musician',
    phone: '',
    email: '',
    tag: 'music',
    totalEvents: 4,
    totalRevenue: 240,
    lastEvent: '2026-10-24',
  },
  {
    id: 37,
    name: 'Aaron Hughes',
    company: 'Musician',
    phone: '',
    email: '',
    tag: 'music',
    totalEvents: 3,
    totalRevenue: 0,
    lastEvent: '2026-08-02',
  },
  {
    id: 38,
    name: 'Shane McCluskey',
    company: 'Musician',
    phone: '',
    email: '',
    tag: 'music',
    totalEvents: 3,
    totalRevenue: 0,
    lastEvent: '2026-12-12',
  },
  {
    id: 39,
    name: 'Mick McLaughlin',
    company: 'Musician',
    phone: '',
    email: '',
    tag: 'music',
    totalEvents: 4,
    totalRevenue: 0,
    lastEvent: '2026-12-19',
  },
  {
    id: 40,
    name: 'Shane',
    company: 'Musician',
    phone: '',
    email: '',
    tag: 'music',
    totalEvents: 2,
    totalRevenue: 0,
    lastEvent: '2026-10-31',
  },
  {
    id: 41,
    name: 'Niall O Reilly',
    company: 'Musician',
    phone: '',
    email: '',
    tag: 'music',
    totalEvents: 5,
    totalRevenue: 0,
    lastEvent: '2026-12-29',
  },
  {
    id: 42,
    name: 'Michael Rafferty',
    company: 'Musician',
    phone: '',
    email: '',
    tag: 'music',
    totalEvents: 3,
    totalRevenue: 0,
    lastEvent: '2026-10-25',
  },
  {
    id: 43,
    name: 'Shane Reynolds',
    company: 'Musician',
    phone: '',
    email: '',
    tag: 'music',
    totalEvents: 5,
    totalRevenue: 0,
    lastEvent: '2026-12-05',
  },
];

export const REAL_PAYMENTS = [];
